/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var DepartmentMemberVisibility;
(function (DepartmentMemberVisibility) {
    DepartmentMemberVisibility[DepartmentMemberVisibility["VisibilityAllMembers"] = 0] = "VisibilityAllMembers";
    DepartmentMemberVisibility[DepartmentMemberVisibility["VisibilityOwnDepartment"] = 1] = "VisibilityOwnDepartment";
    DepartmentMemberVisibility[DepartmentMemberVisibility["VisibilityOnlySelf"] = 2] = "VisibilityOnlySelf";
})(DepartmentMemberVisibility || (DepartmentMemberVisibility = {}));
